import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b2a5a240"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Resignation\n          ")
], -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "\n          Please attach a copy of the employees resignation letter in the\n          attachments & addtional information section.\n        ", -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "leaving_date",
    class: "block text-sm font-medium text-gray-700"
}, "Leaving date *", -1));
const _hoisted_6 = { class: "flex mt-1 rounded-md shadow-sm" };
const _hoisted_7 = ["value", "disabled"];
const _hoisted_8 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm" }, "\n          *The leaving date is the last day that the employee should be paid for\n          working. For example Joe provides his one month's notice to leave on\n          the last day of March, however he has the last week in April booked as\n          holiday. The leave date to enter on the form should be the last day in\n          April, the number of days holiday taken in the final week should be\n          entered in the 'Holidays used' field on the form.\n        ", -1));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "\n          The SSC will process the leaver action and release the P45 to the\n          employee on the next available pay date following receipt of the\n          Leaver Form.\n        ", -1));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700th" }, "\n          If there are further payments to be made to the employee please notify\n          us via Part 2 of the Leaver Form as soon as possible so that these can\n          be made before their final pay is processed and before their P45 is\n          issued, otherwise the employee will be taxed at a higher rate.\n        ", -1));
const _hoisted_12 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_13 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                _hoisted_4,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _hoisted_5,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("input", {
                            id: "leaving-date-input",
                            value: _ctx.formData.leaving_date,
                            disabled: _ctx.disableForm,
                            type: "date",
                            name: "leaving_date",
                            class: _normalizeClass(["flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-md sm:text-sm border-gray-300 disabled:bg-gray-200 disabled:cursor-not-allowed disabled:text-gray-700", {
                                    'error-border': _ctx.v$.formData.leaving_date.$error,
                                    'border-red-500': _ctx.v$.formData.leaving_date.$error,
                                }]),
                            onInput: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                            onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.leaving_date.$touch()))
                        }, null, 42, _hoisted_7)
                    ]),
                    _createTextVNode(),
                    (_ctx.v$.formData.leaving_date.$errors.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "\n            * " + _toDisplayString(_ctx.v$.formData.leaving_date.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                ]),
                _createTextVNode(),
                _hoisted_9,
                _createTextVNode(),
                _hoisted_10,
                _createTextVNode(),
                _hoisted_11
            ]),
            _createTextVNode(),
            (!_ctx.disableForm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                    }, "\n          Save\n        ", 8, _hoisted_13)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
